import type { ComparisonPage } from './types'

export const advisoryAi: ComparisonPage = {
  slug: 'advisory-ai',
  competitorName: 'Advisory AI',
  seo: {
    title: 'WealthSpace vs Advisory AI | UK Financial Adviser Software Comparison 2026',
    description:
      "Compare WealthSpace and Advisory AI for UK financial advisers. Discover why WealthSpace's all-in-one platform, adviser ownership, and FCA-first design make it the top choice.",
    keywords:
      'Advisory AI alternative, WealthSpace vs Advisory AI, Advisory AI competitor, UK adviser software, FCA compliant AI, financial adviser AI comparison, Advisory AI alternative UK, best AI for IFAs',
  },
  hero: {
    title: 'WealthSpace vs Advisory AI:',
    titleAccent: 'The Complete Comparison',
    subtitle:
      "Looking for an Advisory AI alternative? See how WealthSpace's all-in-one platform, adviser ownership model, and UK-native design compare.",
  },
  comparisonTable: [
    { feature: 'All-in-One Platform', wealthspace: 'check', competitor: 'Partial' },
    { feature: 'Built for UK FCA Compliance', wealthspace: 'check', competitor: 'Varies' },
    { feature: 'Adviser-Owned Company', wealthspace: 'check', competitor: 'cross' },
    { feature: 'Privacy Layer (PII Stripping)', wealthspace: 'check', competitor: 'cross' },
    { feature: 'AI Suitability Reports', wealthspace: 'check', competitor: 'check' },
    { feature: 'Meeting Transcription', wealthspace: 'check', competitor: 'Limited' },
    { feature: 'Client Portal with DocuSign', wealthspace: 'check', competitor: 'cross' },
    { feature: 'Apple Watch & CarPlay', wealthspace: 'check', competitor: 'cross' },
    { feature: 'Voice Notes (Rambles)', wealthspace: 'check', competitor: 'cross' },
    { feature: 'Value of Advice Calculator', wealthspace: 'check', competitor: 'cross' },
    { feature: 'Consumer Duty Documentation', wealthspace: 'check', competitor: 'Partial' },
    { feature: 'UK-Based Support', wealthspace: 'check', competitor: 'Varies' },
    { feature: 'Free First Month', wealthspace: 'Yes', competitor: 'Varies' },
  ],
  keyDifferences: {
    title: 'Why Advisers Switch from Advisory AI to WealthSpace',
    items: [
      {
        title: 'Complete Platform',
        description:
          'WealthSpace combines suitability reports, client portal, meeting transcription, voice notes, and compliance tools. No need to piece together multiple solutions.',
      },
      {
        title: 'Adviser Ownership',
        description:
          'Part of the Adviser Equity Group - advisers who use the software own equity. Your feedback directly shapes the product roadmap.',
      },
      {
        title: 'Voice-First Innovation',
        description:
          "Capture ideas anywhere with Apple Watch and CarPlay integration. WealthSpace's \"Rambles\" feature turns voice notes into actionable tasks.",
      },
      {
        title: 'Privacy by Design',
        description:
          "Proprietary privacy layer strips all PII before AI processing. Your clients' sensitive data never touches third-party AI systems.",
      },
    ],
  },
  whyChoose: {
    title: 'Why UK Advisers Choose',
    titleAccent: 'WealthSpace',
    intro:
      "If you're comparing Advisory AI alternatives, here's what makes WealthSpace the top choice for UK financial advisers:",
    items: [
      'All-in-One Solution: Stop paying for multiple tools. Reports, portal, transcription, voice notes, and compliance in one subscription',
      'FCA-First Design: Purpose-built for UK regulatory requirements including Consumer Duty, COBS, and MiFID II',
      "You Own It: The Adviser Equity Group means you're not just a customer - you're an owner with equity",
      'Privacy That Matters: Our proprietary privacy layer strips PII before any AI processing',
      'Work Anywhere: Apple Watch, CarPlay, and mobile voice capture for advisers on the go',
      'UK Support: Real people in the UK who understand FCA requirements and adviser workflows',
      'Clear Pricing: From £125/month. Book a demo to see it in action',
    ],
  },
  whenCompetitor: {
    title: 'When Advisory AI Might Be',
    titleAccent: 'Right For You',
    intro: 'We believe in honest comparisons. Advisory AI may be a better fit if:',
    items: [
      'You only need meeting transcription and already have other tools for reports, portal, and compliance',
      "You're committed to a best-of-breed approach and prefer managing multiple specialist vendors",
      'You have existing integrations that work well with Advisory AI and switching costs are high',
    ],
  },
  cta: {
    title: 'Ready to See the Difference?',
    subtitle:
      'Book a personalised demo and experience the all-in-one platform UK advisers trust.',
    buttonText: 'Book a Demo',
  },
}
